import { BroadcastEvent } from '@core/services';
import { TGuid } from '@core/helpers';

export class ChatLeaveEvent extends BroadcastEvent {
  constructor(public chatId: TGuid) {
    super();
  }
}
